export default __webpack_public_path__ + "/_/goose-error.2ed7ec67.png";